<template>
  <div class="performance-card__meter-container">
    <div class="performance-card__meter" :class="getMeterClasses(metrics, index)" v-for="(metric, index) in metrics" :key="index">
      <span class="performance-card__meter-inner" :class="getInnerMeterClasses(metrics, index)"></span>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    metrics: {
      type: Array,
      required: true
    },
    getMeterClasses: {
      type: Function,
      required: true
    },
    getInnerMeterClasses: {
      type: Function,
      required: true
    }
  }
}
</script>

<style>
  .performance-card__meter-container {
    display: flex;
    width: 100%;
    margin-top: 4px;
    margin-bottom: 4px;
  }

  .performance-card__meter {
    height: 12px;
    background: #C1CCD4;
    border-radius: 50px
  }

  .performance-card__meter-inner {
    display: block;
    height: 100%;
    width: 0;
    transition: width 2s ease;
    will-change: width;
    transform: translateZ(0);
    backface-visibility: hidden;
    perspective: 1000px;
    background: #4369F4;
    border-radius: 50px
  }

  .meter--first,
  .meter-inner--first {
    border-bottom-left-radius: 50px;
    border-top-left-radius: 50px;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  .meter--first {
    margin-right: 3px;
  }

  .meter--second,
  .meter-inner--second {
    border-radius: 0;
  }

  .meter--second {
    margin-left: 3px;
    margin-right: 3px;
  }

  .meter--last,
  .meter-inner--last {
    border-bottom-right-radius: 50px;
    border-top-right-radius: 50px;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }

  .meter--last {
    margin-left: 3px;
  }

  .meter-inner--blue {
    background: #4369F4;
  }

  .meter-inner--green {
    background: #00A6A4;
  }

  .meter-inner--pink {
    background: #B545AA;
  }

</style>
